
//Import React Hooks
import { useEffect, useState } from 'react'

//MUI
import Popover from '@mui/material/Popover';
import SurfingIcon from '@mui/icons-material/Surfing';
import PersonIcon from '@mui/icons-material/Person';
import GradingIcon from '@mui/icons-material/Grading';
import CheckIcon from '@mui/icons-material/Check';
import EuroIcon from '@mui/icons-material/Euro';

//Import created components

// API fetch
import axios from "axios";
import { baseURL } from '../../config/api-config.js';

//Utils 
import convertHoraire from '../../utils/convert_horaire.js';


// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
const weekday = require('dayjs/plugin/weekday')
dayjs.extend(weekday)

function CreneauManager({ creneau }) {

    let [creneauDetails, setCreneauDetails] = useState();
    let [ridersCount, setRidersCount] = useState(0);
    let [matchCount, setMatchCount] = useState(0);
    let [resasCount, setResasCount] = useState(0);
    let [clientsCount, setClientsCount] = useState(0);
    let riderList = []; //list of rider/eleve ids for this creneau
    let pasTropTard = dayjs().isBefore(dayjs(creneau.date)) || dayjs().isSame(dayjs(creneau.date), 'day'); // si current day <= date creneau

    useEffect(() => {
        async function initDetails() { //we add this inner function to manage asynchrone
            let details = await getCreneauInfos();
            setCreneauDetails(details);
        } //end of async function


        initDetails(); //call the inner asnchrone function


    }, [creneau])

    useEffect(() => {

        if (creneauDetails) {
            setRidersCount(creneauDetails.length);
            setMatchCount(creneauDetails.filter((eleve) => eleve.Resa.match === true).length);

            let clientList = [];
            let resaList = [];
            creneauDetails.forEach((creneau) => {
                resaList.push(creneau.Resa.id_resa);
                clientList.push(creneau.Resa.Client.id_client);
            });

            let clientSet = new Set(clientList);
            let resaSet = new Set(resaList);

            setResasCount(Array.from(resaSet).length);
            setClientsCount(Array.from(clientSet).length);



        }

    }, [creneauDetails])

    async function getCreneauInfos() { //jour : date as string

        try {
            const response = await axios({
                method: 'GET',
                url: baseURL + `/creneau-eleve/creneau/${creneau.id_creneau}`,
            });
            //console.log(response);
            const crens = response.data.data;
            return crens;
        } catch (err) {
            console.error(err);
            return null;
        }
    }


    //// ----- popover management
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {

        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? 'popover-creneau' : undefined;
    //// -- end of popover mgmt


    function horairesCreneau() {
        let start = creneau.horaire; //start of creneau as float

        let end = creneau.horaire + creneau.duree; //end of creneau as float

        // return start and end as string (hh:mm) : 
        return [convertHoraire(start, "horaire"), convertHoraire(end, "horaire")];
    }

    function getHeaderClass() {
        let laClasse = "creneau-header-infos";
        //laClasse += riderList.length > 0 ? " creneau-header-infos-selected" : historicCreneau === true ? " creneau-header-infos-historic" : " ";
        return laClasse;
    }

    function customClass(creneau) {
        let laClasse = " ";
        laClasse = creneau.Resa.match === true ? " item-matched " : " ";
        if (creneau.Resa.solde === 0) { laClasse = " item-payed "; }


        return laClasse;
    }




    return (
        <div className="creneau">
            <div className={pasTropTard === true ? "creneau-header-manager" : "creneau-header-manager creneau-header-manager-passe-manager"} onClick={handleClick}>

                <div className={getHeaderClass()}>
                    <p className="creneau-header-infos-debut">{horairesCreneau()[0]}</p>
                    <p className={"creneau-header-infos-fin"}>-</p>
                    <p className={"creneau-header-infos-fin"}>{horairesCreneau()[1]}</p>
                </div>
                {ridersCount > 0 ?
                    <div className="creneau-header-manager-infos">
                        <span className={matchCount === ridersCount ? "fullmatch" : ""}><SurfingIcon /><p>{matchCount}/{ridersCount}</p></span>
                        <span><PersonIcon /><p>{clientsCount}</p></span>
                        <span><GradingIcon /><p>{resasCount}</p></span>

                    </div>
                    : null
                }


            </div>




            <Popover
                className="creneau-popover-root"
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <div className="creneau-popover-manager">
                    <div className="creneau-popover-manager-list">
                        {
                            creneauDetails && creneauDetails.map((creneau) => (
                                <div key={creneau.id_creneau_eleve} className={"creneau-popover-manager-list-item " + customClass(creneau)}>
                                    {creneau.Resa.match === true ? <CheckIcon /> : null}
                                    {creneau.Resa.match === true && creneau.Resa.solde === 0 ? <EuroIcon /> : null}
                                    <p>{creneau.Eleve.prenom} ({creneau.Eleve.age})</p>
                                    <p>:</p>
                                    <p>{creneau.Resa.Client.nom}</p>

                                </div>
                            ))
                        }

                    </div>
                    <p>session : {creneau.id_creneau}</p>
                </div>
            </Popover>

        </div>
    );
}

export default CreneauManager;